import React from 'react';
import { useLang, LANGUAGES } from '../../context/LanguageContext';
import { useSiteConfig, resolveImageUrl } from '../../context/SiteConfigContext';

const Footer = () => {
  const { lang, setLang } = useLang();
  const { config, staticMode } = useSiteConfig();
  const f = config?.footer?.[lang] || {};
  const logoUrl = resolveImageUrl(config?.branding?.logo);
  return (
    <footer className="bg-[#0a231d] text-white/70 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-10 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div className="max-w-md flex items-start gap-4">
          {logoUrl && (
            <img src={logoUrl} alt="Exotic Tours Martinique" className="h-14 w-14 rounded-full object-cover ring-1 ring-white/15 shrink-0" />
          )}
          <div>
            <div className="font-serif text-[15px] text-white">Exotic Tours Martinique</div>
            <p className="mt-2 text-[13px] leading-relaxed">{f.brand_line}</p>
          </div>
        </div>
        <div className="text-[12px] flex flex-col md:items-end gap-2">
          <span className="text-white/40">{f.available}</span>
          <div className="flex gap-2">
            {LANGUAGES.map((l) => (
              <button
                key={l.code}
                onClick={() => setLang(l.code)}
                title={l.name}
                aria-label={l.name}
                className={`text-[15px] leading-none transition-opacity ${lang === l.code ? 'opacity-100' : 'opacity-50 hover:opacity-90'}`}
              >
                <span role="img" aria-hidden>{l.flag}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-4 flex flex-col md:flex-row justify-between gap-2 text-[11px] text-white/40">
          <span>{f.rights}</span>
          {!staticMode && <a href="/admin" className="hover:text-white/70 transition-colors">Admin</a>}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
